var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-listing-web"},[(!_vm.basket.length)?_c('div',[_c('empty-cart')],1):_c('div',[_c('cart-with-orders')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }